/**
 * 初始化菜单
 */

import request from "@/service/request";

export async function getMenus() {
    return await request.get("/system/menu/init");
}